import { render, staticRenderFns } from "./programa-resumen.vue?vue&type=template&id=581680e5&"
import script from "./programa-resumen.component.ts?vue&type=script&lang=ts&"
export * from "./programa-resumen.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports